import { format } from 'date-fns'

export const notNestedObjectReplaceDatesWithStrings = (
	inputObject: Record<string | number, unknown>
) => {
	// TODO: Remove structuredClone
	// eslint-disable-next-line
	const object = structuredClone(inputObject)

	for (const [key, value] of Object.entries(object)) {
		if (!Object.prototype.hasOwnProperty.call(object, key)) {
			return
		}

		if (value instanceof Date) {
			object[key] = format(value, 'yyyy-MM-dd')
		}
	}

	return object
}
